import { MicrosoftIcon } from './Icons';

/**
 * The house login card — mark on a slate tile, app name, then sign-in.
 *
 * Deliberately no email/password fields, unlike AP Central: this app has no
 * local accounts at all, so a password box could only ever mislead. Every door
 * here is Microsoft 365.
 */
export function LoginScreen() {
  return (
    <main className="login-wrap">
      <div className="login-card">
        <div className="login-tile">
          <img src="/on-services-mark.svg" alt="" width={58} height={70} />
        </div>
        <h1 className="login-title">PDF Toolkit</h1>
        <p className="login-sub">Sign in to your account</p>

        <a className="btn btn--ms" href="/auth/login">
          <MicrosoftIcon />
          Sign in with Microsoft 365
        </a>

        <p className="login-note">Use your ON Services work account.</p>
      </div>
    </main>
  );
}
